import defer from 'lodash/defer';
import log from 'chameleon/packages/blue-book-player/utility/log';
import { destroyPlayer } from 'chameleon/packages/blue-book-player/hooks/use-learnosity-provider';
import Cookies from 'universal-cookie';

export const learnositySubmit = (
  learnosityApp,
  submissionReadyCallback = () => {},
  isImpersonating = false,
) => {
  if (isImpersonating) {
    return true;
  }

  if (!learnosityApp) {
    log('error', 'Learnosity app is not available');
    return;
  }

  submissionReadyCallback(false);
  const submitSuccess = () => {
    try {
      /**
       * Learnosity fix for allowing proctoring tool to receive finish event
       * Fix proposed by learnosity team
       * */

      // After the assessment is submitted to learnosity
      // Destroy the player and don't allow further changes.
      defer(() => {
        submissionReadyCallback(true);
        destroyPlayer(learnosityApp);
      });
    } catch (error) {
      log('error', error);
      setTimeout(() => {
        submissionReadyCallback(true);
        destroyPlayer(learnosityApp);
      }, 5000);
    }
  };

  const submitSettings = {
    success: submitSuccess,
  };
  learnosityApp.submit(submitSettings);
};

export const learnosityExitPlayer = (subject, router, locationState) => {
  const cookies = new Cookies();

  const overviewBackLink = cookies.get('rldbci')
    ? '/close?rldbsl=1&rldbqn=1'
    : locationState && locationState.returnPath
      ? locationState.returnPath
      : `/${subject}/assignments`;

  router.push(overviewBackLink);
};
